import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react'; // @ts-expect-error module is untyped

import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import * as ThemeQueryField from '../../../constants/ThemeQueryField';
import AssetBusinessTypeUrls from '../../../constants/urls/AssetBusinessType';
import FilterSideNav from './FilterSideNav';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { deployed } from '../../../utils/env'; // @ts-expect-error module is untyped

import { getAssetBusinessTypeI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import { getFullPublicThemesUrl } from '../../../utils/urls';
import { getIsPrerenderUserAgent } from 'ecosystem-marketplace-core/utils/userAgent';
import { useUsedBusinessTypeValues } from '../../../hooks/useUsedBusinessTypeValues';

function useBusinessTypeOptions() {
  const businessTypeValues = useUsedBusinessTypeValues();
  const options = useMemo(() => {
    return businessTypeValues.map(value => ({
      text: unescapedText(getAssetBusinessTypeI18nKey(value)),
      value
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [businessTypeValues]);
  return options;
}

function useBusinessTypeNavOptions() {
  const options = useBusinessTypeOptions();
  const isDeployed = deployed();
  return options.reduce((navOptions, option) => {
    const {
      value: optionValue
    } = option;
    const url = AssetBusinessTypeUrls[optionValue];

    if (url) {
      navOptions.push(Object.assign({}, option, {
        href: `${getFullPublicThemesUrl('en', !isDeployed)}/${url}`
      }));
    }

    return navOptions;
  }, []);
}

function BusinessTypeNav({
  value
}) {
  const options = useBusinessTypeNavOptions();
  const activeValue = value.length === 1 ? value[0] : null;
  return /*#__PURE__*/_jsx(FilterSideNav, {
    "aria-label": unescapedText('marketplace-assets-ui.assets.filters.businessType.title'),
    name: ThemeQueryField.BUSINESS_TYPES,
    options: options,
    value: activeValue
  });
}

export default function BusinessTypeFilter({
  disabled,
  onChange,
  scrollable = true,
  value
}) {
  const isPrerender = getIsPrerenderUserAgent();
  const options = useBusinessTypeOptions();
  return isPrerender ? /*#__PURE__*/_jsx(BusinessTypeNav, {
    value: value
  }) : /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.businessType.title'),
    disabled: disabled,
    multi: true,
    name: ThemeQueryField.BUSINESS_TYPES,
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
}